import { render, staticRenderFns } from "./MailTemplates.edit.vue?vue&type=template&id=7b1e61ee&"
import script from "./MailTemplates.edit.vue?vue&type=script&lang=js&"
export * from "./MailTemplates.edit.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplates.edit.vue?vue&type=style&index=0&id=7b1e61ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports